module.exports = __webpack_public_path__ + "img/menu.4fd8450c.svg";